import React from "react";
import { connect } from 'react-redux';
import countries from 'i18n-iso-countries';
import { states, getStatesList, getCountryList } from '../../sc-utilities/CountriesAndUSstatesList';
import BillingAccountForm from "./BillingAccountForm";
import * as Yup from "yup";
import * as actions from './store/billingAccountActions';
import {hasPermission} from "../../sc-utilities";

const BillingAccountEdit = props => {
    const { editing, activeCustomer, translations,userLanguage, onEditBillingAccount, permissions } = props;

    const handleSubmit = async data => {
        const requestData = { ...data };
        requestData['AccountantID'] = requestData['Accountant'] ? requestData['Accountant'].value : null;

        let result = await onEditBillingAccount({...requestData, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack();
        }
    };

    let formSettings = {
        Validation: {
            BillingMode: Yup.string().required('Required'),
            Status: Yup.string().required('Required'),
            ActivationDate: Yup.date()
                .required(),
            ExpiresAt: Yup.date()
                .required(),
            BillingDay: Yup.number().required('Required').min(1).max(28),
            CustomerOrder: Yup.string().notRequired('Required'),
            TermsOfPayment: Yup.string().notRequired('Required'),
            CustomerID: Yup.string().notRequired('Required'),
            Accountant: Yup.string().notRequired('Required'),
            Language: Yup.string().required('Required'),
            PhoneNumber: Yup.string().notRequired('Required'),
            Email: Yup.string().email().notRequired('Required'),
            CustomerAddress: Yup.boolean().notRequired(),
            AddressLine1: Yup.string().required('Required'),
            AddressLine2: Yup.string().notRequired(),
            City: Yup.string().required('Required'),
            State: Yup.string().when("Country", {
                is: "United States of America",
                then: Yup.string().required()
            }),
            Country: Yup.string().required('Required')
        },
        FormTitle: translations['billing_account_update'] || 'Update billing account',
        ButtonSubmit: hasPermission(permissions, 'billing_account_update') ? {
            Title: translations['save'] || 'SAVE',
            Color: 'primary'
        } : null,
    };

    return <BillingAccountForm
        formSettings={formSettings}
        countryList={getCountryList(countries, userLanguage)}
        usStatesList={getStatesList(states)}
        handleSubmit={handleSubmit}
        loading={editing}
        translations={translations}
    />
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        editing: state.billing.accounts.editing,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
        userLanguage: state?.core?.login?.userSettings?.DefaultLanguage || 'en',
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onEditBillingAccount: params => dispatch(actions.editBillingAccount(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BillingAccountEdit);